import { useContext, useEffect, useState } from 'react';
import css3 from '../../Approvals/css/approval-table.module.css';
//../css/approval-table.module.css
import {FiMoreHorizontal as MoreIcon} from 'react-icons/fi';
import {MdOutlineArrowBackIosNew as LBtn,MdOutlineArrowForwardIos as RBtn} from 'react-icons/md';
//import css4 from '../../../Approvals/css/approval-table.module.css';
import css4 from  '../../Approvals/css/approval-table.module.css'
import styled from '@emotion/styled';
import { setAllBatchInvite } from '../../../../reduxSlice/batchInviteSlice';
import { useDispatch, useSelector } from 'react-redux';
import {AiOutlineSearch as SearchIcon} from 'react-icons/ai';
import {IoReload as ReloadIcon} from 'react-icons/io5';
import { FilterDropDown, Loading } from '../../../../ui-components';
import Checkbox from '@mui/material/Checkbox';
interface TrainingInvites {
    ApplicantId: string;
    ApplicantName?: string;
    ApplicantEmail?: string;
    ApplicantPhone?: string;
  }

interface BatchInviteTableProps {
    data: TrainingInvites[] ;
    searchData?: string
    setSearchData: React.Dispatch<React.SetStateAction<string>>
}

export const DATA_PER_PAGE = 10;

const BatchInviteTable = ({data,searchData, setSearchData}: BatchInviteTableProps) => {

    const [activeData,setActiveData] = useState<any>([]);
    const [pageData,setPageData] = useState<any>([]);
    const [currentPage,setCurrentPage] = useState<number>(0);
    const [pageArr,setPageArr] = useState<any>([]);
    const [isCheck, setIsCheck] = useState<string[]>([]);
    const [list, setList] = useState<TrainingInvites[]>([]);
    const [isCheckAll, setIsCheckAll] = useState(false);
   

    const DATA_PER_PAGE = 10;

    const dispatch = useDispatch()

    const setSearchData1 = (input: any) => {
        setSearchData(input)
        setList([]);
        setIsCheck([]);
        setIsCheckAll(false);
    }

      

    const handlePrevous = () =>{
        if(currentPage === 0){
            if(pageArr.length > 1){
                setCurrentPage(pageArr.at(-1))
                return false;
            }
            setCurrentPage(0);
            return false;

        }
        setCurrentPage(currentPage-1);
    }

    const handleNext = ()=>{
        if(pageArr.length > 1){
            if(currentPage === pageArr.at(-1)){
                setCurrentPage(0);
                return false;
            }
            setCurrentPage(currentPage+1);
            return false;
        }
        setCurrentPage(0);
    }

    const handleSelectAll = (e?: React.ChangeEvent<HTMLInputElement>) => {
        setIsCheckAll(!isCheckAll);
        setIsCheck(list?.map((item: any) => item?.ApplicantId))
        if(isCheckAll){
            setIsCheck([]);
        }
    }

    const handleClick = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {id, checked} = e.target;
        setIsCheck([...isCheck, id]);
        if(!checked ){
            setIsCheck(isCheck.filter(item => item !== id));
        }
    }

    const filterBatchApprovalData = list?.filter((data1: any) =>{
        return isCheck.some((data2: any) => {
            return data1?.ApplicantId === data2;
        })
    });
    
    

    useEffect(() => {
        dispatch(setAllBatchInvite(filterBatchApprovalData));
        if(list?.length < 1) return
        list?.length !== isCheck?.length ? setIsCheckAll(false) : setIsCheckAll(true);
    }, [isCheck, ])



    useEffect(() => {
        setList(data);
    }, [list]);




    useEffect(() => {
        //isCheckAll && dispatch(setAllBatchInvite(filterBatchApprovalData));
        if(data && data?.length > 0) {

            setActiveData(data);
            let lastPage = Math.ceil(data?.length/10);
            let i = 0;
            let arr = [];
            for (i = 0; i < lastPage; i++){
                arr.push(i);
            }

            setPageArr(arr);
            setPageData(data.slice(0,DATA_PER_PAGE));
        }
    }, [data])


    useEffect(() => {
        if(activeData && activeData.length > 0){
            let start = currentPage*DATA_PER_PAGE;
            let stop = start+DATA_PER_PAGE;
            setPageData(data?.slice(start,stop));
        }
    }, [currentPage])


    return ( 
            <>
                <Section1>
                    <div className='searchWrapper'>
                        <label className={'searchForm'}>
                            <span className={'sI'}><SearchIcon/></span>
                            <input 
                                value = {searchData} 
                                onChange={(e) => setSearchData1(e.target.value)} 
                                type="text" placeholder='Search' />
                            <button className={'rBtn'} type="submit"><ReloadIcon/></button>
                        </label>
                        {/* <FilterDropDown  text="Role" bg="#E2E4E9" color="#020D08" options={7} />
                        <FilterDropDown  text="Data Range" bg="#E2E4E9" color= '#020D08' options={3} /> */}
                    </div>
                    <span>Select All  <Checkbox id='selectAll' onChange={handleSelectAll} checked={isCheckAll} sx={{marginBlockEnd: '3px'}}/></span>
                </Section1>
            {
                data?.length > 0 ? 
                <Table >   
                    <div className = {'t-head'} >
                        <span></span>
                        <span>Applicant Id</span>
                        <span>Full Name</span>
                        <span>Applicant Email</span>
                        <span>Appllciant Phone Number</span>
                    </div>
                    <Tbody>
                        {pageData && pageData.length > 0 && pageData.map((eData:TrainingInvites,index:number):any =>
                            <div key={index}>
                                    <div><Checkbox onChange={handleClick} id={eData?.ApplicantId} checked={isCheck.includes(eData?.ApplicantId)}/></div>
                                    <span>{eData?.ApplicantId?eData?.ApplicantId.slice(0,15):''}...</span>
                                    <span>{eData?.ApplicantName}</span>
                                    <span>{eData?.ApplicantEmail}</span>
                                    <span>{eData?.ApplicantPhone}</span>
                            </div>
                        )}
                    </Tbody>
                    <div className={css3.pagination}>
                        <div>
                            <button className={`${css3.lBtn} ${css3.btn}`} onClick={handlePrevous}><LBtn/></button>
                            {pageArr && pageArr.length > 0 && pageArr.map((ePage: number, index: number) => {

                                if(index <= 2 && currentPage <= 2) return (<span
                                    style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                    key={ePage} 
                                    onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>)  

                                if(index == currentPage ) return (<span
                                    style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                    key={ePage} 
                                    onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>)  

                                if(index >= pageArr.length - 3 && currentPage >= pageArr.length -3) return (<span
                                    style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                    key={ePage} 
                                    onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>)  

                                if(index == pageArr.length-1) return (
                                <>
                                    <>...</>
                                    <span 
                                    style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                    key={ePage} 
                                    onClick={() => setCurrentPage(ePage)}
                                    >
                                        {ePage + 1}
                                    </span>
                                </>
                                )  

                                if(index == 0 ) return (
                                <>
                                    <span 
                                    style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                    key={ePage} 
                                    onClick={() => setCurrentPage(ePage)}
                                    >
                                        {ePage + 1}
                                    </span>
                                    <>...</>
                                </>)  

                                })} 
                            <button className={`${css3.rBtn} ${css3.btn}`}  ><RBtn/></button>
                        </div>
                    </div>
                </Table> :
            <NoResult>No Results</NoResult>
            }
         </>
    )
}

const Table = styled.div`
        padding-block-start: 10px;
        & > .table-div{
            display:flex;
            flex-direction:column;
            gap:5px;
            margin-top:10px;
        }
        & > .table-div > div{
            width:100%;
        }
        & .t-head{
            display:grid;
            grid-template-columns: 0.3fr repeat(4,1fr);
            background-color:#E0FAEE;
            padding:15px 10px;
        }
`
const Tbody = styled.div`
        display: flex;
        gap:8px;
        flex-direction: column;
        border-top:2px solid #E2E4E9;
        border-bottom:2px solid #E2E4E9;
        min-height: 250px;

        & > div{
            border-left:2px solid #fff;
            display:grid;
            grid-template-columns: 0.3fr repeat(4,1fr);
            padding:10px 7px;

            & > span {
                display: flex;
                align-items: center;
            }
        }
        & > div:hover{
            border-left-color:#293856;
        }
`

const Section1 = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 46px;
    & span{
        font-size: 16px;
    }

    & .searchWrapper{
        margin-block-start: 1.6px;
        display: flex;
        gap: 10px;
    }

    & .searchForm{
        width: 250px;
        position: relative;
        display: flex;
        align-items: center;
    }

    &   .sI{
        position: absolute;
        left:7px;
    }

    &  .rBtn{
        position: absolute;
        right:7px;
        border:none;
        outline:none;
        background-color: transparent;
        cursor: pointer;
    }
    &   .searchForm > input{
        width:100%;
        outline:none;
        border: 1px solid #E2E4E9;
        padding:15px 30px 15px 30px;
        border-radius: 5px;
}
`

const NoResult = styled.div`
  margin-block-end: 25px;
`

export default BatchInviteTable;


